<script lang="ts">
export default {
  name: 'CompaniesAnalysisScatterHeader',
}
</script>
<script setup lang="ts">
import DatePicker from '../../../../components/DatePicker.vue'

interface Period {
  startDate: Date | string
  endDate: Date | string
}
interface DisabledDates {
  from: Date | string
  to: Date | string
}
interface Props {
  period: Period
  disabledDates?: DisabledDates
}
const props = withDefaults(defineProps<Props>(), {
  period: () => ({
    startDate: new Date(),
    endDate: new Date()
  }),
})

interface Emits {
  (e: 'change-period', value: Period): void
}
const emit = defineEmits<Emits>()

const handleInput = (value: Period): void => {
  emit('change-period', value)
}

</script>
<template>
  <div class="p-filtersA">
    <div class="p-filtersA__left">
      <slot name="select" />
    </div>
    <div class="p-filtersA__right">
      <DatePicker
        :initial-dates="props.period"
        :disabled-dates="props.disabledDates"
        opens="left"
        @input="handleInput"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
</style>
